function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from '../utils/classNames';
/**
 * The OverlayFooter component is a support component for Overlay which allows the passing
 * of content, mainly, buttons or links to be displayed over the Overlay.
 *
 * - [Design Spec](https://atlas.np.tools.playstation.net/design/7ca5464e-1b6b-48f4-81fa-36c7a00d69cf/2?bounds=-0.183,0.151,0.964,0.655)
 *
 * ## Related Components
 * - [Overlay](https://github.sie.sony.com/SIE/web-common-toolkit/tree/master/packages/ui/react-components/src/Overlay)
 *
 * ## Usage
 *
 * ```jsx
 * <OverlayFooter>
 *   <Button ctaType="tertiary">Learn More, I am a lot longer</Button>
 *   <Button ctaType="primary">I Got it!</Button>
 * </OverlayFooter>
 * ```
 */

var OverlayFooter = /*#__PURE__*/function (_PureComponent) {
  _inherits(OverlayFooter, _PureComponent);

  var _super = _createSuper(OverlayFooter);

  function OverlayFooter() {
    _classCallCheck(this, OverlayFooter);

    return _super.apply(this, arguments);
  }

  _createClass(OverlayFooter, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          qa = _this$props.qa,
          className = _this$props.className,
          variant = _this$props.variant,
          ctaLayout = _this$props.ctaLayout,
          spacer = _this$props.spacer;
      var RootEl = spacer ? 'div' : 'footer';
      return /*#__PURE__*/React.createElement(RootEl, {
        "data-qa": qa,
        "aria-hidden": spacer,
        className: classNames('psw-overlay-footer', 'psw-l-line-center', 'psw-fill-x', 'psw-p-7', spacer && 'psw-is-spacer psw-hidden', variant === 'standard' && 'psw-b-t-divider psw-c-b-support psw-c-bg-1', className)
      }, /*#__PURE__*/React.createElement("div", {
        className: classNames(ctaLayout === 'mobile-stack' && 'psw-overlay-button-group', ctaLayout === 'always-stack' && 'psw-l-stack-center psw-l-space-y-4', 'psw-l-shrink-wrap')
      }, children));
    }
  }]);

  return OverlayFooter;
}(PureComponent);

OverlayFooter.defaultProps = {
  qa: '',
  className: '',
  variant: 'standard',
  ctaLayout: 'mobile-stack',
  children: null,
  spacer: false
};
OverlayFooter.propTypes = {
  /**
   * The qa selector to set for the instance of the component
   */
  qa: PropTypes.string,

  /**
   * CSS classes to add to the component
   */
  className: PropTypes.string,

  /**
   * Presentational variant (standard, transparent)
   */
  variant: PropTypes.oneOf(['standard', 'transparent']),

  /**
   * Layout directive for ctas / children
   */
  ctaLayout: PropTypes.oneOf(['always-stack', 'mobile-stack']),

  /**
   * Overlay content
   */
  children: PropTypes.arrayOf(PropTypes.any),

  /**
   * Whether to render the footer as a spacer or not
   */
  spacer: PropTypes.bool
};
export default OverlayFooter;